import { SELECT_CUSTOMER_SUCCESS } from '../customers';

import {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  LOGIN_SUCCESS,
  LOGIN_FAILURE
} from './actions';

const initialState = {
  isAuthenticating: false,
  userId: null,
  activeCustomerId: null,
  customerIds: [],
  errorStatus: null
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_REQUEST:
      return {
        ...state,
        isAuthenticating: true
      };
    case AUTH_SUCCESS:
      return {
        ...state,
        isAuthenticating: false,
        userId: action.payload.userId,
        customerIds: action.payload.customerIds,
        activeCustomerId: action.payload.activeCustomerId
      };
    case AUTH_FAILURE:
      return {
        ...state,
        isAuthenticating: false,
        userId: null,
        customerIds: [],
        activeCustomerId: null
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        userId: action.payload.userId,
        customerIds: action.payload.customerIds,
        activeCustomerId: action.payload.activeCustomerId
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        userId: null,
        customerIds: [],
        activeCustomerId: null
      };

    case SELECT_CUSTOMER_SUCCESS:
      return {
        ...state,
        activeCustomerId: action.payload.id
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/reducer.js